import { useQuery } from '@apollo/client'

import { queries } from '../../graphql'
import { Box, Container, Text } from '..'
import { useBranding } from '../../hooks/useBranding'

export function AdvisorHeader() {
  const { data } = useQuery(queries.user.me)
  const advisorName = data?.me?.name || ''
  const { getDebugBorder } = useBranding()

  return (
    <Box
      component="header"
      sx={{
        backgroundColor: 'secondary.main',
        m: 0,
        py: 3,
        ...getDebugBorder('Advisor Header Background', '#FF0000'),
      }}
    >
      <Container maxWidth="lg" sx={{ mb: 0 }}>
        <Box sx={{ width: '100%', display: 'flex', flexWrap: 'noWrap' }}>
          <Text.H4 color="secondary.contrastText">{advisorName || 'Advisor Dashboard'}</Text.H4>
        </Box>
      </Container>
    </Box>
  )
}
